<template>
  <div class="fillSpace" v-if="isProductLoaded">
    <ModalHelpScreen
      header="Bienvenue dans votre nouvel outil digital de démonstration verres Essilor !"
      content="pour sélectionner les démonstrations verres Essilor disponibles dans l’outil."
      footer="Tous droits réservés ©  2020 - Essilor"
      v-show="isModalVisible"
      @close="closeModal"
    />
    <ModalReport
      @messageSent="isPopupVisible = true"
      v-show="showModalReport"
      @close="showModalReport = false"
      @openHelpModal="openHelpModal()"
      @openCguModal="isCguContentDisplay = true"
    />
    <PopupValid v-show="isPopupVisible" @close="isPopupVisible = false" />

    <div v-if="showModalPodium" class="greyBackground"></div>
    <div v-if="showModalPodium" class="popup">
      <h2 class="textpopup">{{ getWebcontrol('Accueil-Texte-MessagePodiumDown') }}</h2>
      <button class="buttonpopup" @click="showModalPodium = false">retour</button>
    </div>
    <AppMenu>
      <template v-slot:topright>
        <div class="logo-essi-expert">
          <img src="../assets/logo-essi-expert.svg" />
        </div>
        <div class="btns-top-right">
          <RoundButton
            class="btn-settings bordered"
            href="/settings"
            image="ic-settings.svg"
            v-if="isManagerOrOwner"
            :heightAdjust="heightAdjustSettings"
            :width="currentScreenWidth > 1024 ? 35 : 30"
          />
          <RoundButton
            @click.native="showModalReport = true"
            class="btn-help bordered"
            text="?"
            :width="currentScreenWidth > 1024 ? 40 : 30"
          />
        </div>
      </template>
      <template v-slot:topleft>
        <SemiButton
          class="marqueButton"
          href="/products"
          v-bind:bold="getWebcontrol('Accueil-Bouton-DecouvrirProduitBold')"
          image="ic-arrow-link.svg"
          v-bind:text="getWebcontrol('Accueil-Bouton-DecouvrirProduit')"
        />
      </template>
      <template v-slot:bottomleft>
        <div class="podiumButton" @click="goToPodium()" @mouseleave="mouseOver" v-show="showIconPodium">
          <PlainButton
            image="ic-arrow-link-white.svg"
            v-bind:bold="getWebcontrol('Accueil-Bouton-AccederAPodiumBold')"
            v-bind:text="getWebcontrol('Accueil-Bouton-AccederAPodium')"
          />
        </div>
        <div class="podiumButton" @click="goToPodium()" @mouseover="mouseOut" v-show="!showIconPodium">
          <PlainButton
            image="img-logo-podium.svg"
            v-bind:bold="getWebcontrol('Accueil-Bouton-AccederAPodiumBold')"
            v-bind:text="getWebcontrol('Accueil-Bouton-AccederAPodium')"
          />
        </div>
      </template>
      <template v-slot:bottomrightincontainer>
        <img class="logo-bottom-right" src="../assets/logo.png" />
      </template>
    </AppMenu>

    <div class="padded navigationPaneContainer">
      <Pane class="home-bloc small" background="#FFE25D">
        <NavigationPane
          v-bind:title="getWebcontrol('Accueil-Titre-RaconterVotreJourneeBold')"
          v-bind:subtitle="getWebcontrol('Accueil-Titre-RaconterVotreJournee')"
          image="home1.png"
          class="first"
          href="/relate/1"
        />
      </Pane>

      <Pane class="home-bloc big" background="#0088ec">
        <NavigationPane
          v-bind:title="getWebcontrol('Accueil-Titre-ConfigurerVosVerresBold')"
          image="img-verre.svg"
          class="second"
          v-bind:subtitle="getWebcontrol('Accueil-Titre-ConfigurerVosVerres')"
          href="/demos/configurator"
        />
      </Pane>

      <Pane class="home-bloc medium" background="#F2F2F2">
        <NavigationPane
          v-bind:title="getWebcontrol('Accueil-Titre-ComprendreVotreVisionBold')"
          image="vision.png"
          class="third"
          v-bind:subtitle="getWebcontrol('Accueil-Titre-ComprendreVotreVision')"
          href="/Understand"
        />
      </Pane>
    </div>
  </div>
</template>

<script>
import AppMenu from '@Components/Menu.vue';
import RoundButton from '@Components/Menus/RoundButton.vue';
import Pane from '@Components/Pane.vue';
import NavigationPane from '@Components/Panes/Navigation.vue';
import PlainButton from '@Components/Menus/PlainButton.vue';
import SemiButton from '@Components/Menus/SemiButton.vue';
import ModalHelpScreen from '../components/Menus/ModalHelpScreen';
import ModalReport from '../components/Menus/ModalReport';
import PopupValid from '../components/Menus/PopupValid';

export default {
  components: {
    PopupValid,
    ModalReport,
    ModalHelpScreen,
    AppMenu,
    RoundButton,
    Pane,
    NavigationPane,
    PlainButton,
    SemiButton,
  },
  beforeMount() {
    this.isModalVisible = !this.isModalHelpVisited;
  },
  mounted() {
    this.$gtag.pageview({
      page_title: 'Home page',
      page_path: '/Home Page',
      page_location: window.location.href,
    });
    window.localStorage.removeItem('crizal_left');
    window.localStorage.removeItem('crizal_right');

    this.initModalHelp();

    this.$store.dispatch('QuizzFilled', false);
    const tab = ['protect', 'optimize', 'correct'];
    for (let elem of tab) {
      this.$store.commit('selectProduct', {
        category: elem,
        id: null,
      });
    }
  },
  data: function() {
    return {
      showModalPodium: false,
      showIconPodium: true,
      showModalReport: false,
      isModalVisible: false,
      isPopupVisible: false,
      isCguContentDisplay: false,
    };
  },

  computed: {
    isProductLoaded() {
      return this.$store.getters.isProductsLoaded();
    },
    isManagerOrOwner() {
      return sessionStorage.getItem('userRole') === 'MANAGER' || sessionStorage.getItem('userRole') === 'OWNER';
    },
    heightAdjustSettings() {
      return CSS.supports('( -moz-user-select:unset )') ? 16 : -1;
    },
    currentScreenWidth() {
      return window.outerWidth;
    },
    isModalHelpVisited() {
      return !!sessionStorage.getItem('modalHelpSeen');
    },
  },
  methods: {
    openHelpModal() {
      this.showModalReport = false;
      this.isModalVisible = true;
    },
    acceptCgu() {
      this.$store.dispatch('acceptCgu');
      this.isCguAccepted = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    goToPodium() {
      if (this.$store.getters.isPodiumActive()) {
        if (sessionStorage.getItem('storeId') === '9610560') {
          window.open('https://demopodiumweb.azurewebsites.net/', '_blank');
        } else {
          window.open('https://podium.essilor.fr/', '_blank');
        }
      } else {
        this.showModalPodium = true;
      }
    },
    getWebcontrol(key) {
      return this.$store.getters.getValueById(key);
    },
    mouseOver: function() {
      this.showIconPodium = false;
    },
    mouseOut: function() {
      this.showIconPodium = true;
    },
    initModalHelp() {
      if (!this.isModalHelpVisited) sessionStorage.setItem('modalHelpSeen', 'visited');
    },
  },
};
</script>

<style scoped>
.textpopup {
  position: absolute;
  top: 40%;
  width: 100%;
}

.buttonpopup {
  position: absolute;
  width: 100px;
  height: 40px;
  border-radius: 20px;
  border: 1px solid gray;
  bottom: 10px;
  left: 50%;
  transform: translate(-50%, -50%);
}

.popup {
  position: absolute;
  height: 300px;
  width: 500px;
  background-color: white;
  border: 1px solid gray;
  border-radius: 20px;
  z-index: 1010;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.greyBackground {
  position: fixed;
  background-color: gray;
  width: 100%;
  height: 100%;
  z-index: 1009;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  opacity: 0.5;
}
.podiumButton {
  position: absolute;
  transform: translateY(-59px);
}
.podiumButton button {
  font-family: AkhandSoft;
  font-size: 22px;
}
.marqueButton {
  position: relative;
  font-family: AkhandSoft;
  font-size: 23px;
}

.fillSpace {
  width: 100%;
  height: 100%;
  padding-bottom: 140px;
}

.navigationPaneContainer {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  height: 100%;
}

.navigationPaneContainer .home-bloc {
  height: 100%;
  position: relative;
  overflow: visible;
}

.navigationPaneContainer .home-bloc.small {
  height: 75%;
}

.navigationPaneContainer .home-bloc.big {
  height: 100%;
  margin-left: 3%;
  margin-right: 3%;
  /* margin-bottom: 7%; */
}

.navigationPaneContainer .home-bloc.medium {
  height: 85%;
  /* margin-bottom: 3.5%; */
}

.btns-top-right {
  display: flex;
  margin-top: 21px;
}

.btn-settings:hover {
  border: 1px solid black;
}

.btn-settings {
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  margin-right: 20px;
  padding-bottom: 40px;
  width: 48px;
  height: 48px;
}

.logo-essi-expert {
  align-self: center;
  padding: 20px;
  margin-top: 36px;
}

.btn-help {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  font-size: 25px;
  border: 1px solid lightgrey;
  border-radius: 50%;
  text-align: center;
}

.btn-help:hover {
  border: 1px solid black;
}

/*
résolution moins de 1280
*/
/* @media (max-width: 1024px) {
  .logo-essi-expert {
    padding: 0;
  }
  .logo-essi-expert img {
    width: 160px;
  }
  .podiumButton button {
    font-family: AkhandSoft;
    font-size: 10px;
  }
  button {
    width: 140px;
    height: 40px;
  }
  .podiumButton {
    position: absolute;
    left: 98px;
    bottom: 56px;
  }
  .btn-help {
    width: 40px;
  }

  .marqueButton {
    font-size: 15px;
  }
} */
</style>
